import styled from "styled-components";

export const SocialLinksWrapper = styled.nav`
  width: auto;
`;

export const SocialLinksList = styled.ul`
  align-items: center;
  display: flex;
  justify-content: center;
  list-style: none;
`;

export const SocialLinksItem = styled.li`
  margin: 0 0.5rem;
`;

export const SocialLinksLink = styled.a`
  color: #8630F2;
  text-decoration: none;
  transition: color 0.5s;

  &:hover {
    color: var(--esx-black);
  }
`;

export const IconWrapper = styled.div`
  fill: #bbb;
  width: 30px;
  height: 30px;
`;
